import React from "react";
import { CircleDollarSign, Clock, AlertTriangle, ScrollText, CalendarClock, HourglassIcon } from "lucide-react";
import { formatMoney } from "../lib/api";

const Cell = ({ label, value, sub, accent, icon: Icon, testid, wide, subColor }) => (
  <div
    data-testid={testid}
    className={
      "relative bg-ledger-surface border border-ledger-border p-6 md:p-7 " +
      (wide ? "md:col-span-2" : "")
    }
  >
    <div className="flex items-center justify-between text-[11px] uppercase tracking-[0.18em] text-ledger-muted">
      <span>{label}</span>
      <Icon className="h-4 w-4" style={{ color: accent }} />
    </div>
    <div
      className="mt-3 font-display text-4xl md:text-5xl text-ledger-ink"
      style={{ letterSpacing: "-0.02em" }}
    >
      {value}
    </div>
    {sub && (
      <div className="mt-2 font-mono text-[11px]" style={{ color: subColor || "#525252" }}>
        {sub}
      </div>
    )}
  </div>
);

export const MetricsBar = ({ metrics }) => {
  if (!metrics) return null;
  return (
    <div className="space-y-4">
      <div
        data-testid="metrics-bento"
        className="grid grid-cols-2 md:grid-cols-4 border border-ledger-border bg-ledger-surface divide-x divide-y md:divide-y-0 divide-ledger-border"
      >
        <Cell
          testid="metric-open"
          label="Open Promises"
          value={metrics.open_count}
          sub={`${metrics.fulfilled_count} fulfilled · ${metrics.conditional_count} conditional`}
          icon={ScrollText}
          accent="#171717"
        />
        <Cell
          testid="metric-due-today"
          label="Due Today"
          value={metrics.due_today_count}
          sub="ship it"
          icon={HourglassIcon}
          accent="#92400E"
        />
        <Cell
          testid="metric-due-week"
          label="Due This Week"
          value={metrics.due_this_week_count}
          sub="within 7 days"
          icon={Clock}
          accent="#1D4ED8"
        />
        <Cell
          testid="metric-overdue"
          label="Overdue"
          value={metrics.overdue_count}
          sub="need follow-up"
          icon={AlertTriangle}
          accent="#B91C1C"
          subColor="#B91C1C"
        />
      </div>

      <div
        data-testid="metric-money"
        className="relative bg-ledger-goldBg border border-ledger-goldBorder p-6 md:p-7 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8"
      >
        <div>
          <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.18em] text-[#92400E]">
            <CircleDollarSign className="h-4 w-4 text-[#B45309]" />
            Attached to Open Promises
          </div>
          <div className="mt-2 font-mono text-4xl text-[#78350F]" style={{ letterSpacing: "-0.01em" }}>
            {formatMoney(metrics.money_attached || 0)}
          </div>
        </div>
        <div className="md:border-l md:border-[#F59E0B] md:pl-8">
          <div className="text-[11px] uppercase tracking-[0.18em] text-[#92400E]">
            Money expected this week
          </div>
          <div className="mt-2 font-mono text-3xl text-[#78350F]">
            {formatMoney(metrics.money_due_soon || 0)}
          </div>
        </div>
        <div className="md:border-l md:border-[#F59E0B] md:pl-8">
          <div className="text-[11px] uppercase tracking-[0.18em] text-[#B91C1C]">
            Overdue financial commitments
          </div>
          <div className="mt-2 font-mono text-3xl text-[#7F1D1D]">
            {formatMoney(metrics.money_overdue || 0)}
          </div>
        </div>
      </div>
    </div>
  );
};
